import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { StripeProvider, Elements } from 'react-stripe-elements';
import Dashboard from '../dashboard.js';
import MyOrganization from '../organization/myorganization.js';
import MyCourses from '../course/mycourses.js';
import Announcements from './announcements.js';
import CourseManagement from '../course/management/coursemanagement.js'
import OrganizationManagement from '../organization/organizationmanagement.js';
import CourseContentManagement from '../course/management/coursecontentmanagement.js';
import CoursePricingManagement from '../course/management/coursepricingmanagement.js';
import CourseUserManagement from '../course/management/courseusermanagement.js';
import UserManagement from '../user/usermanagement.js';
import CourseInfo from '../course/catalog/courseinfo.js';
import CourseCatalog from '../course/catalog/coursecatalog.js';
import Cart from '../course/catalog/cart.js';
import Checkout from '../course/catalog/checkout.js';
import CourseLauncher from '../course/launchcourse.js';
import FormList from '../forms/formlist.js';
import Form from '../forms/form.js';
import FormBuilder from '../forms/formbuilder.js';
import OrgUserCourseResults from '../organization/orgusercourseresults.js';
import MyCourseResults from '../course/mycourseresults.js';
import EditList from '../lists/editlist.js';

export default class LMSMain extends React.Component
{
    componentDidMount()
    {
        console.log("LMSMain mounted")
    }
    render()
    {
        return (
            <Switch>
                <Route path="/Cart" render={(routeprops) =>
                    <Cart api={this.props.api} cart={this.props.cart} 
                        addToCart={this.props.addToCart} removeFromCart={this.props.removeFromCart}
                        clearCart={this.props.clearCart} orgUsers={this.props.orgUsers}
                        buyTypeChanged={this.props.buyTypeChanged} checkCartUserChanged={this.props.checkCartUserChanged}
                        cartUserSelectAll={this.props.cartUserSelectAll} cartUserDeselectAll={this.props.cartUserDeselectAll} />
                } />
                <Route path="/Checkout" render={(routeprops) =>
                    <div className="lmsdisplayarea">
                        <h3>Checkout</h3>
                        <StripeProvider apiKey="pk_test_Dz2SaNm6mHsdZmvPxggtBE8c">
                            <Elements>
                                <Checkout api={this.props.api} cart={this.props.cart} />
                            </Elements>
                        </StripeProvider>
                    </div>
                } />
                <Route path="/MyCourses" render={(routeprops) =>
                    <div className="lmsdisplayarea" style={{marginTop: "20px"}}>
                        <h3>My Courses</h3>
                        <MyCourses api={this.props.api} />
                    </div>
                } />
                <Route path="/Shop" render={(routeprops) =>
                    <CourseCatalog api={this.props.api} cart={this.props.cart} 
                        addToCart={this.props.addToCart} removeFromCart={this.props.removeFromCart} />
                } />
                <Route path="/MyOrganization" render={(routeprops) =>
                    <MyOrganization api={this.props.api} />
                } />
                <Route path="/OrgUserCourse/:id" render={(routeprops) =>
                    <OrgUserCourseResults api={this.props.api} id ={routeprops.match.params.id} />
                } />
                <Route path="/MyCourseResults/:id" render={(routeprops) =>
                    <MyCourseResults api={this.props.api} id ={routeprops.match.params.id} />
                } />
                <Route path="/Announcements" render={(routeprops) =>
                    <Announcements api={this.props.api} />
                } />
                <Route path="/Courses/:id" render={(routeprops) => 
                    <CourseInfo api={this.props.api} courseID={routeprops.match.params.id} 
                        cart={this.props.cart} addToCart={this.props.addToCart}
                        removeFromCart={this.props.removeFromCart} />
                } />
                <Route path="/LaunchCourse/:id" render={(routeprops) =>
                    <CourseLauncher api={this.props.api} courseID={routeprops.match.params.id} />
                } />
                <Route path="/CourseManagement" render={() =>
                    <CourseManagement api={this.props.api} />
                } />
                <Route path="/OrganizationManagement" render={() =>
                    <OrganizationManagement api={this.props.api} />
                } />
                <Route path="/UserManagement" render={() => 
                    <UserManagement api={this.props.api} />
                } />
                <Route path="/CourseContentManagement/:id" render={(routerprops) =>
                    <CourseContentManagement api={this.props.api} courseID={routerprops.match.params.id} />
                } />
                <Route path="/CoursePricingManagement/:id" render={(routerprops) =>
                    <CoursePricingManagement api={this.props.api} courseID={routerprops.match.params.id} />
                } />
                <Route path="/CourseUsers/:id" render={(routerprops) =>
                    <CourseUserManagement api={this.props.api} courseID={routerprops.match.params.id} />
                } />
                <Route exact path="/Forms" render={() => 
                    <FormList api={this.props.api} />
                } />
                <Route path="/Forms/new" component={() =>
                    <FormBuilder api={this.props.api} id={0} />
                } />
                <Route path="/Forms/edit/:id" render={(routerprops) =>
                    <FormBuilder api={this.props.api} id={routerprops.match.params.id} />
                } />
                <Route path="/Forms/:id" component={(routerprops) => 
                    <Form api={this.props.api} id={routerprops.match.params.id} />
                } />
                <Route path="/Lists/new" component={(routerprops) => 
                    <EditList api={this.props.api} id={0} />
                } />
                <Route path="/Lists/edit/:id" component={(routerprops) => 
                    <EditList api={this.props.api} id={routerprops.match.params.id} />
                } />
                <Route path="/" render={() =>
                    <Dashboard api={this.props.api} />
                } />
            </Switch>
        )
    }
}


// WEBPACK FOOTER //
// ./src/general/lmsmain.js